import { render, staticRenderFns } from "./ImageEditor.vue?vue&type=template&id=1027d4cc&scoped=true&"
import script from "./ImageEditor.vue?vue&type=script&lang=js&"
export * from "./ImageEditor.vue?vue&type=script&lang=js&"
import style0 from "./ImageEditor.vue?vue&type=style&index=0&id=1027d4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027d4cc",
  null
  
)

export default component.exports